import React, { Component } from 'react';
import loaderIcon from '../../../../assets/icons/loader.svg';
import alertCircleIcon from '../../../../assets/icons/alert-circle.svg';
import summaryIcon from '../../../../assets/icons/summary.svg';

export default class SummaryBadge extends Component {
  render() {
    const { onClick, model, provider, loading, status, error, disabled } = this.props;

    // Determine badge state: loading, error, success, or none
    const badgeClass = loading ? 'loading' : (status || 'none');
    
    let title = '';
    let label = '';
    let icon = null;
    // Don't disable error state - allow clicking to view details
    let isDisabled = loading || (disabled && status !== 'error');

    if (loading) {
      title = 'Generating summary...';
      label = 'Summarizing...';
      icon = <img src={loaderIcon} className="summary-badge-icon spinner" alt="" />;
    } else if (status === 'error') {
      title = error || 'Summary generation failed - Click to view details';
      label = 'Error';
      icon = <img src={alertCircleIcon} className="summary-badge-icon" alt="" />;
    } else if (status === 'success') {
      title = `Summarized by ${model || 'AI'} (${provider || 'unknown'}) - Click to view`;
      label = 'Summary';
      icon = <img src={summaryIcon} className="summary-badge-icon" alt="" />;
    } else {
      // No summary yet - show disabled state
      title = disabled ? 'No summary available - Generate one from the summary modal' : 'Click to open summary modal';
      label = 'Summary';
      icon = <img src={summaryIcon} className="summary-badge-icon" alt="" />;
    }

    return (
      <button
        type="button"
        className={`summary-badge ${badgeClass}`}
        onClick={onClick}
        title={title}
        aria-label={label}
        disabled={isDisabled}
      >
        {icon}
        <span className="summary-badge-text">{label}</span>
      </button>
    );
  }
}
